import VideoPlayer from './VideoPlayer';
import VideoBackground from './VideoBackground';

export default VideoPlayer;
export { VideoBackground };
